import { render, staticRenderFns } from "./ConnectionStats.vue?vue&type=template&id=6bf39c14&"
import script from "./ConnectionStats.vue?vue&type=script&lang=js&"
export * from "./ConnectionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports